import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { OutstandingStatisticsService } from './outstanding-statistics.service';
import { ProjectsService } from 'app/_services/projects.service';

const moment = require('moment');
@Component({
  selector: 'app-outstanding-statistics-manager',
  templateUrl: './outstanding-statistics.component.html',
  styleUrls: ['./outstanding-statistics.component.scss']
})
export class OutstandingStatisticsManagerComponent implements OnInit {

  notSpam = false;
  brandDropDownSettings: any;
  brandSelected = [];
  brandSelectedFilter = [];
  brands = [];
  discussProject = [];
  selectedDiscussProjects = [];
  reportName = "";
  dataReport: Object;

  projectDropDownSettings: any;
  projectSelected = [];
  projectSelectedFilter = [];
  projects = [];

  typeReport = 'day';
  typeReportFilter = 'day';

  typeAction = 'create';

  dtOptions: DataTables.Settings = {};
  dataList = [];
  dataTableShow = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  daterange: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };

  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };

  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };


  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private OutstandingStatisticsService: OutstandingStatisticsService,
    private modalService: BsModalService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: false,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: false,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;

    this.options.startDate = this.daterange.start;
    this.options.endDate =  this.daterange.end;
  }

  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }

  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });
  }

  onProjectSelectedChange() {
    this.projectsService.getProjectDiscussionByProject( {projects : this.projectSelected}).subscribe(res => {
      this.discussProject = [];
      this.selectedDiscussProjects = [];
      if (res.success) {
        res.data.projectsDiscussion
        .forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.discussProject.push(obj);
        });
      }
    })
  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.OutstandingStatisticsService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name,
            image : 'data:image/png;base64,'+element.image
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {

    let brandSelected = JSON.parse(JSON.stringify(this.brandSelected));
    brandSelected.forEach(item => {
      delete item.image
    });

    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: brandSelected,
      typeReport: this.typeReportFilter,
      report_code: ["BCNBTH"]
    };
    this.dataTableShow = false;
    this.OutstandingStatisticsService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
    });
  }

  getStyle(brand: String) {
    let _brand = brand.toLowerCase()
    switch (_brand) {
      case 'vinaphone':
        return 'bg-vinaphone';
      case 'viettel':
        return 'bg-viettel'
      case 'mobifone':
        return 'bg-mobifone'
      case 'vietnammobile':
        return 'bg-vietnammobile'
      case 'fpt':
          return 'bg-fpt'
          case 'vinaphone':
        return 'bg-vinaphone';
      case 'viettel':
        return 'bg-viettel'
      case 'mobifone':
        return 'bg-mobifone'
      case 'vietnammobile':
        return 'bg-vietnammobile'
      case 'gscl_vinaphone':
        return 'bg-vinaphone';
      case 'gscl_viettel':
        return 'bg-viettel'
      case 'gscl_mobifone':
        return 'bg-mobifone'
      case 'gscl_vietnammobile':
        return 'bg-vietnammobile'
      default:
        return 'bg-primary'
    }
  }
  getImageBrand(brand : String) {
    for (let index = 0; index < this.brands.length; index++) {
      const element = this.brands[index];
      if(element.itemName == brand) {
        return element.image;
      }
    }
    return '';
  }



  clickReport() {
    if (this.projectSelected.length == 0 && this.brandSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    if (this.projectSelected.length > 4 || this.brandSelected.length > 4) {
      this.toastrService.warning("Vui lòng chọn tối đa 4 chủ đề hoặc thương hiệu", "Thông báo!");
      return;
    }
    this.dataReport = {};
    // let timeRange = Math.ceil((this.daterange.end.valueOf() - this.daterange.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }

    let filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      discussProjects : this.selectedDiscussProjects,
      type: this.typeReport,
      index: 'full',
      notSpam : this.notSpam
    };
    this.OutstandingStatisticsService.getReport({ filter: filter,  index: 'full' }).subscribe(response => {
      let data = response.data;
      if (data) {
        let result = [];
        let aggregations = data.aggregations;
        for (var _key in aggregations) {

          let reportItem = {
            name: _key,
            totalNews: aggregations[_key].statistic.docTypesCount.news.doc_count || 0,
            totalPosts: aggregations[_key].statistic.docTypesCount.post.doc_count || 0,
            commentCount: aggregations[_key].statistic.docTypesCount.comment.doc_count || 0,
            likeCount: aggregations[_key].statistic.docTypesCount.post.likeCount.value  + aggregations[_key].statistic.docTypesCount.post.numReactions.value ,
            shareCount: aggregations[_key].statistic.docTypesCount.post.shareCount.value || 0,
            style : this.getStyle(_key),
            isProject : this.projectSelected.length > 0 ?  true : false,
            image : this.getImageBrand(_key)
          }
          reportItem['totalInteractive'] = reportItem.totalPosts + reportItem.totalNews + reportItem.commentCount + reportItem.likeCount +reportItem.shareCount; 
          result.push(reportItem);
        }

        // move Vinaphone lên đầu
        result.forEach(function(item,i){
          if(item.name.toLowerCase() === "vinaphone"){
            result.splice(i, 1);
            result.unshift(item);
          }
        });    
        // end move Vinaphone lên đầu
     
        let brandSelected = JSON.parse(JSON.stringify(this.brandSelected));
        brandSelected.forEach(item => {
          delete item.image
        });
        this.dataReport = {
          report_desc: "Báo cáo thống kê nổi bật thương hiệu",
          report_type: this.typeReport,
          report_name: "Báo cáo thống kê nổi bật thương hiệu " + this.daterange.start.format('DD/MM/YYYY') + " đến ngày " + this.daterange.end.format('DD/MM/YYYY'),
          report_project: this.projectSelected,
          report_brand: brandSelected,
          report_start_date: new Date(this.daterange.start.valueOf()),
          report_end_date: new Date(this.daterange.end.valueOf()),
          report_code: "BCNBTH",
          data: {
            result: result,
            time: `${this.daterange.start.format('DD/MM/YYYY')} - ${this.daterange.end.format('DD/MM/YYYY')}`
          }
        }
      }
    });
    // console.log(filter);
  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.OutstandingStatisticsService.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef = this.modalService.show(modalRef);
  }

  deleteReport() {
    this.OutstandingStatisticsService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
    this.modalRef2.hide();
  }

  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/outstanding-statistics/outstanding-statistics.component.ts